/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/views/layout/Layout'

const componentsRouter = {
  path: '/base',
  component: Layout,
  name: 'Base',
  menuid: 1,
  systemtypeid: 0,
  meta: {
    title: 'BaseTitle',
    icon: 'wechat'
  },
  children: [
    {
      path: 'estate/index',
      component: () => import('@/views/base/estate/list'),
      name: 'BaseEstateList',
      menuid: 6,
      systemtypeid: 0,
      meta: {title: 'BaseEstateList', icon: 'table'}
    },  
    {
      path: 'timetype/index',
      component: () => import('@/views/base/timetype/list'),
      name: 'TimeTypeList',
      menuid: 18,
      systemtypeid: 0,
      meta: {title: 'TimeTypeList', icon: 'dashboard'}
    }, 
    {
      path: 'level',
      component: () => import('@/views/base/user/level/list'),
      name: 'UserLevelList',
      menuid: 14,
      systemtypeid: 0,
      meta: {title: 'UserLevelList', icon: 'size'}
    },  
    {
      path: 'role/index',
      component: () => import('@/views/base/role/list'),
      name: 'BaseRoleList',
      menuid: 2,
      systemtypeid: 0,
      meta: {title: 'BaseRoleList', icon: 'wechat'}
    },
    {
      path: 'manager/index',
      component: () => import('@/views/base/manager/list'),
      name: 'BaseManagerList',
      menuid: 90,
      systemtypeid: 0,
      meta: {title: 'BaseManagerList', icon: 'people'}
    },  
  ]
}
export default componentsRouter



// WEBPACK FOOTER //
// ./src/router/modules/base.js